export default function Process() {
  const steps = [
    {
      number: '01',
      icon: 'ri-calendar-check-line',
      title: 'Call for Appointment',
      description: 'Book a consultation at your home, office, or our location. Choose a time that works best for you.'
    },
    {
      number: '02',
      icon: 'ri-palette-line',
      title: 'Select Style & Fabric',
      description: 'Browse hundreds of premium fabrics and customize every detail with expert guidance from our consultants.'
    },
    {
      number: '03',
      icon: 'ri-ruler-2-line',
      title: 'Precise Measurements',
      description: 'Our experts take detailed measurements ensuring your garment fits perfectly to your unique body shape.'
    },
    {
      number: '04',
      icon: 'ri-scissors-cut-line',
      title: 'Expert Tailoring',
      description: 'Master craftsmen handcraft your garment with meticulous attention to detail and quality.'
    },
    {
      number: '05',
      icon: 'ri-truck-line',
      title: 'Delivery & Fitting',
      description: 'Receive your custom garment in 6 to 8 weeks* with final fitting adjustments if needed.'
    }
  ];

  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            How It <span className="text-[#C9A961]">Works</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A simple, seamless process from <strong>consultation to delivery</strong> in just five easy steps
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-[#C9A961]/20 via-[#C9A961] to-[#C9A961]/20"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-gray-50 rounded-2xl p-8 hover:bg-white hover:shadow-xl transition-all duration-300 border border-gray-100 h-full">
                  {/* Step Number */}
                  <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-[#C9A961] to-[#B89851] rounded-full flex items-center justify-center text-white font-bold shadow-lg">
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center mb-6 mx-auto shadow-md">
                    <i className={`${step.icon} text-3xl text-[#C9A961]`}></i>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                    {step.title}
                  </h3>
                  
                  <p className="text-gray-600 text-center leading-relaxed text-sm">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            Ready to experience the perfect fit?
          </p>
          <a 
            href="tel:866-857-8487" 
            className="inline-flex items-center bg-gray-900 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-gray-800 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap"
          >
            <i className="ri-phone-line mr-3 text-xl"></i>
            Call 866-857-8487 Now
          </a>
        </div>
      </div>
    </section>
  );
}